/**
 * <DailySchedule
 *		// please describe props here
 *	/>
 *
 * - When there is a nesting tr, we use tbody as a row.
 *
 * @parent anybody
 * @children
 * @stateful
 * @stateless
 */
import React, { PropTypes } from 'react';
import getTimetable from 'controllers/school/getTimetable'
import filterEvents from './filterEvents'
import moment from 'moment'
import locale from './locale'
import isEqual from 'lodash/isEqual';

import './DailySchedule.scss'

class DailySchedule extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      date: moment().format('YYYY-MM-DD'),
      list: [],
      morningList: [],
      afternoonList: [],
    }

    this.filter = props.setting.filter

    this.fetchSchedule = this.fetchSchedule.bind(this)

  }

  componentWillMount() {
    this.fetchSchedule()
  }

  componentWillReceiveProps({setting}){
    if (!isEqual(this.filter, setting.filter)) {
      this.filter = setting.filter
      this.sortTime();
    }
  }

  fetchSchedule(){
    const schoolId = localStorage.getItem('schoolId')
    const {date} = this.state
    getTimetable(schoolId, {start_date: date, end_date: date, detail: 1})
    .then((res) => {
      this.setState({list: res.data.result_list}, ()=>{
        this.sortTime()
      })
    })
  }

  sortTime(){
    let {list} = this.state
    let morningList = []
    let afternoonList = []

    const filteredList = filterEvents(list, this.filter)

    filteredList.map((item) => {
      if(moment(item.lStartTime).format('HH:mm') < '12:00'){
        morningList.push(item)
      } else {
        afternoonList.push(item)
      }
    })

    this.setState({morningList, afternoonList})
  }

  renderColumn(time, list){
    const {displayClassroom, displayLessonName, displayTeacherName} = this.props.setting

    return(
      <div className='columnHeader'>
        <ul>
          <li className='date-li'>{time}</li>
          {list.map((item) => {
            const {calendarColor, class_name, lName, lStartTime, lEndTime, classroom_name, teacher_list} = item
            return(
              <li className='lesson-li'>
                <div className='row'>
                  <div className='border' style={{ backgroundColor: calendarColor || '#9B9B9B'  }}></div>
                  <div className='col-xs-6'>
                    {displayLessonName && <h5>{class_name} {`(${lName})`}</h5>}
                    <h6>{moment(lStartTime).format('hh:mm') + ' - ' + moment(lEndTime).format('hh:mm')}</h6>
                    {displayClassroom && 
                      <div className='classroom'>
                        {__('Classroom', locale)}: {classroom_name? <p>{classroom_name}</p> : ' N/A'}
                      </div>
                    }
                  </div>
                  <div className='col-xs-6'>
                    {displayTeacherName && 
                      <div className='teacherList'>
                        {__('Teacher', locale)}: 
                        {teacher_list.length>0 ? teacher_list.map((teacher) => {
                          return (
                            <p>{teacher.stName || ''}</p>
                          )
                        }): ' N/A'}
                      </div>
                    }
                  </div>
                </div>
              </li>
            )
          })}
        </ul>
      </div>
    )
  }

  render() {
    const {schoolName, schoolLogo} = this.props
    const {morningList, afternoonList, date} = this.state
    const schoolId = localStorage.getItem('schoolId')

    return (
      <div className='DailySchedule'>
        <div className='schedule-header'>
          <div>
            <img src={schoolLogo} className='schoolLogo pull-left' />
            <h2 className='pull-left'>{schoolName}</h2>
            <div className='pull-right changeDay dontPrintMe'>
              <a href='#' onClick={() => {
                this.setState({
                  date: moment(date).subtract('days', 1).format('YYYY-MM-DD'),
                }, () => {
                  getTimetable(schoolId, {
                    start_date: this.state.date,
                    end_date: this.state.date,
                    detail: 1
                  })
                  .then((res) => {
                    this.setState({list: res.data.result_list}, ()=>{
                      this.sortTime()
                    })
                  })
                })
              }}>
                <i className='fa icon-left-dir'></i>
                <span>{__('Yesterday', locale)}</span>
              </a>
              <a href='#' onClick={() => {
                this.setState({
                  date: moment().format('YYYY-MM-DD'),
                }, () => {
                  getTimetable(schoolId, {start_date: this.state.date, end_date: this.state.date, detail: 1})
                  .then((res) => {
                    this.setState({list: res.data.result_list}, ()=>{
                      this.sortTime()
                    })
                  })
                })
              }}>
                <span>{__('Today', locale)}</span>
              </a>
              <a href='#' onClick={() => {
                this.setState({
                  date: moment(date).add('days', 1).format('YYYY-MM-DD'),
                }, () => {
                  getTimetable(schoolId, {
                    start_date: this.state.date,
                    end_date: this.state.date,
                    detail: 1
                  })
                  .then((res) => {
                    this.setState({list: res.data.result_list}, ()=>{
                      this.sortTime()
                    })
                  })
                })
              }}>
                <span>{__('Tomorrow', locale)}</span>
                <i className='fa icon-right-dir'></i>
              </a>
            </div>
          </div>
          <div className='text-center scheduleTitle'>{moment(date).format('MMM DD ddd')}</div>
        </div>

        <div className='schedule-content'>
          {this.renderColumn(__('Morning', locale), morningList)}
          {this.renderColumn(__('Afternoon', locale), afternoonList)}
        </div>

      </div>
    )
  }
}

export default DailySchedule;



// WEBPACK FOOTER //
// ./src/shared/ScheduleDisplayer/DailySchedule.js